import React, { Component, useMemo } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import AssignmentSelect from './renderAssignmentSelect';
import CalendarInputField from './CalendarInputField';
import AssignmentPopupCalendar from './AssignmentPopupCalendar';
import TextHover from '../../components/TextHover'
import loadingGif from '../../assets/img/loading-pinwheel.gif';
import moment from 'moment'
import '../../assets/css/components/assignment-form.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useForm, useField } from 'react-form'
import { buildStudentGroupings } from '../../util'

function AssignmentTextField(props) {
const { meta: { error, isTouched, isValidating }, getInputProps } = useField(props.name)
  return <CalendarInputField {...props} input={getInputProps(props)}/>
}

function AssignmentSelectField(props) {
    const { meta: {error, isTouched, isValidating }, getInputProps, setValue, value } = useField(props.name)
  return <AssignmentSelect fieldValue={value} {...props} input={{id: props.name, name: props.name}}/>
}

const BulkAssignmentUpsertionForm = ({assignableContent, fetchedRequestId, isFetching, submitWasSuccessful, isUpserting, upsertError, onSubmitNew, upsertedAssignmentObject, setSelectedDate, checkTextDate, setSelectedIndex, selectedDateArray, selectedIndex, studentGroupings, onSubmit, defaultAssignees, resolveDecision, getConflictMessage, conflicts, resetNotifications, expandableDetails, showExpandableDetails, getSuccessMessage, formattedUpsertionGroupInfo, formChanged, onAssigneeChange }) => {

  const getAssignmentVerb = ()=>assignableContent.type === 'modules' ? 'Unlock' : 'Queue'

  const getDefaultValues =  {assignmentTimestamps:[], studentGroupings: (_.isEmpty(defaultAssignees) ? [] : defaultAssignees) }

  const currentConflictNotification = _.isEmpty(conflicts) ? {} : conflicts[0]

  const currentConflictType = _.isEmpty(conflicts) ? "" : currentConflictNotification.type

  // form 1 is the long blue buttons, form 2 is the red and blue small buttons, 0 is no current conflict
  const currentConflictFormat = ()=>{
    switch(currentConflictType){
      case "PartialPriorProgress": case "IndividualToClassDiffDate" :
        return 1
        break;
      case "FullPriorProgress": case "ClassToIndividualDiffDate" :
        return 2
        break;
      default:
        return 0
    }
  }

  const currentConflictYesButtonText = ()=> {
    switch(currentConflictType){
      case "PartialPriorProgress":
        return "Yes, only assign to those who haven't started/completed the quest"
        break;
      case "FullPriorProgress":
        return "Yes, make them start over"
        break;
      case "IndividualToClassDiffDate" :
        return "Yes, merge with class"
        break;
      case "ClassToIndividualDiffDate" :
        return "Yes"
    }
  }

  const currentConflictNoButtonText = ()=> {
    switch(currentConflictType){
      case "PartialPriorProgress":
        return "No, assign to everyone"
        break;
      case "FullPriorProgress": case "ClassToIndividualDiffDate" :
        return "No, make changes"
        break;
      case "IndividualToClassDiffDate" :
        return "No, keep their assignments separate from the class"
        break;
    }
  }

  //react form related functions and hooks
  const { Form, values, meta, setFieldValue }= useForm({
    onSubmit: (values, instance)=>{
      onSubmit(values)
    },
    defaultValues: useMemo(()=>getDefaultValues,[])
  })

  return(
    <Form className='assignment-form' id='assignment-form'>
      <AssignmentSelectField
        name='studentGroupings'
        label='Assign To Students or Classes'
        multiple
        wrapperClass='groupings-input'
        data={buildStudentGroupings(studentGroupings)}
        onAssigneeChange={onAssigneeChange}
        updateValue={setFieldValue}
      />

      <div>
        <div className='queue-row'>
          <AssignmentPopupCalendar selectedDate={selectedDateArray[selectedIndex]} onSelect={setSelectedDate}/>
        {(assignableContent.type === 'quests' || assignableContent.type === 'modules') &&
          <AssignmentTextField
            type='text'
            wrapperClass='queue-input'
            placeholder='Pick a date'
            name='assignmentTimestamps[0]'
            onChange={checkTextDate}
            onFocus={setSelectedIndex}
            value={selectedDateArray[0]}
            label={`${getAssignmentVerb()} On`}
            updateValue={setFieldValue}
            />
        }
        {assignableContent.type === 'sequences' &&
          <span className='sequence-timestamp-block'>
            {_.map(assignableContent.quests, (quest, index)=>
              <AssignmentTextField
                type='text'
                placeholder='Pick a date'
                name={`assignmentTimestamps[${index}]`}
                value={ selectedDateArray[index]}
                onChange={checkTextDate}
                onFocus={setSelectedIndex}
                label={`Quest ${index + 1} ${getAssignmentVerb()} On`}
                updateValue={setFieldValue}
              />
            )}
          </span>
        }
        </div>
          <br/>
            {(_.isEqual(currentConflictFormat(), 2)) &&
          <div className="decision-notification-container-two">
            <div className='notification-text'>{getConflictMessage(currentConflictNotification)}</div>
            <img className={`loading-gif ${(isUpserting || isFetching) ? '' : 'hidden'}`} src={loadingGif}/>
            <div className={'expandable-content-container ' + (showExpandableDetails ? 'active' : '')}>{ showExpandableDetails ? expandableDetails : null}</div>
            <div className='button-row'>
              <button className={'button-yes' + (isUpserting ? ' disabled' : '')} disabled={isUpserting || isFetching} onClick={()=>resolveDecision(currentConflictType,true)}>{currentConflictYesButtonText()}</button>
              <button className={'button-no' + (isUpserting ? ' disabled' : '')} disabled={isUpserting || isFetching} onClick={()=>resetNotifications()}>{currentConflictNoButtonText()}</button>
            </div>
          </div>
        }
        {(_.isEqual(currentConflictFormat(), 1)) &&
          <div className="decision-notification-container">
            <div className='notification-text'>{getConflictMessage(currentConflictNotification)}</div>
            <img className={`loading-gif ${(isUpserting || isFetching) ? '' : 'hidden'}`} src={loadingGif}/>
            <div className={'expandable-content-container ' + (showExpandableDetails ? 'active' : '')}>{ showExpandableDetails ? expandableDetails : null}</div>
              <div className='button-row'>
                <button className={'button-yes' + (isUpserting ? ' disabled': '')} disabled={isUpserting || isFetching} onClick={()=>resolveDecision(currentConflictType, true)}>{currentConflictYesButtonText()}</button>
                <button className={'button-no' + (isUpserting ? ' disabled' : '')} disabled={isUpserting || isFetching} onClick={()=>resolveDecision(currentConflictType, false)}>{currentConflictNoButtonText()}</button>
              </div>
          </div>
        }
        {_.isEmpty(conflicts) &&
          <div className="initial-form-container">
            <div className='form-results'>
              {!_.isEmpty(upsertedAssignmentObject.assignments) &&
              <div className='success-container'><FontAwesomeIcon icon='check-circle' color='#4FCA15' /><div className='form-success'>{getSuccessMessage(formattedUpsertionGroupInfo)}</div></div>
              }
              {upsertError && <span className='error'>{upsertError}</span>}
            </div>
            <div className={'expandable-content-container ' + (showExpandableDetails ? 'active' : '')}>{ showExpandableDetails ? expandableDetails : null}</div>
            <div className='submit-container'>
              <button type='submit'
                disabled={isUpserting || isFetching}
                className={'btn btn-primary btn-submit' + ((!_.isEmpty(upsertedAssignmentObject.assignments) && !formChanged ) ? ' hidden' : '')}
              >
                  {`Save Assignment(s)`}
                </button>
              <img className={`loading-gif ${(isUpserting || isFetching) ? '' : 'hidden'}`} src={loadingGif}/>
            </div>
          </div>
        }
      </div>
    </Form>
  );
}

const { object,array } = PropTypes
BulkAssignmentUpsertionForm.propTypes = {
  assignableContent: object.isRequired,
  studentGroupings: array.isRequired
}

export default BulkAssignmentUpsertionForm;
